/**
 * Whether a parsed node starts clear of its parent's transform and visibility, by the rule in
 * `godot/scene/parentSpace.ts`. The mounted scene and the passes that run before anything mounts ask it
 * alike, so both break the chain at the same node.
 */
import { isTypeUnknowable } from '../parser/typeUnknowable.js';
import { escapesParentSpace } from '../godot/scene/parentSpace.js';
/**
 * A node whose class this file cannot know stays with its parent. An `instance=` node takes the
 * sub-scene root's class (ADR-0013), and a `.glb` root is a Node3D.
 */
export function nodeEscapesParent(node, parentFamily) {
    return !isTypeUnknowable(node) && escapesParentSpace(parentFamily, node.type);
}
//# sourceMappingURL=nodeEscapesParent.js.map